// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1677":"69ccd569","8244":"69ccd569"}[chunkId] + ".chunk.css";
};